import React, { useEffect, useContext } from 'react';
import { useFindOrder, useUpdateOrder } from '../../../hooks/useOrder';
import { EntitiesContext } from '../../../App';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const icon = <FontAwesomeIcon icon={faCircleNotch} className="icon fa-spin is-large"/>

export default function Complete() {
  const entities = useContext(EntitiesContext);
  const update = useUpdateOrder();

  const URI = new URL(window.location.href);
  const data = decodeURI(URI.searchParams.get("data"));
  const res = JSON.parse(data);

  const order = entities.state.get('order').get(parseInt(res.state));

  useFindOrder(parseInt(res.state));

  useEffect(() => {
    if (order && res.transaction_id) {
      update.mutate(order
        .set('status', 'paid')
        .set('remote_transaction_id', res.transaction_id)
      )
    }
  }, [order]);

  if (!res.state) {
    return <div className="has-text-centered">You have reached this page in error</div>;
  }

  if (!res.transaction_id) {
    return <div className="has-text-centered">
      <div className="title">Unable to Process Payment</div>
      <button className="button is-info" onClick={() => window.close()}>Close</button>
      {icon}
    </div>
  }

  if (res.transaction_id) {
    return <div className="has-text-centered">
      <div className="title">Payment Processed</div>
      <div className="title">Order ID: {res.state}</div>
      <div className="subtitle">Write this Order ID on an envelope and add all vendor tags for this order.</div>
      <button className="button is-info" onClick={() => window.close()}>Close</button>
    </div>
  }
}
